import { BaseModule } from "./base.module";

export class StateMachineModule extends BaseModule {

	debugMode = false;
	logExpectedUnhandledStates = false;

	/**
	* Backup, for testing purposes
	*/
	actors = [
		this.createActor(0),
	];

	constructor() {
		super();
		console.log('[StateMachineModule] constructor');
	}

	/**
	 * 
	 * @param actor This is the actor that the state will be changed in. It is only this one that is to be changed, to keep it simple. (the other actor will be iterated somewhere else, as the first parameter of this method)
	 * @param otherActor other actor, to compare the actor to in next(), if needed
	 * @param state look to see if this state is present in the actor states
	 * @param event look to see if this event is present in the actor state
	 * // should return string for now
	 * @returns string|object|array
	 */
	actorStateMachine = (actor, otherActor, state, event, context) => {
		if (this.debugMode === true) {
			console.log(
				'[StateMachineModule] actorStateMachine with actor',
				Object.assign({}, { actor: actor }).actor,
				', with current state',
				Object.assign({}, { state: state }).state,
				'and receiving event', Object.assign({}, { event: event }).event
			);
		}
		if (actor.states) {
			// console.log('actor.states', actor.states);
			if (typeof actor.states[state] !== 'undefined') {
				// console.log('with state', actor.states[state]);
				if (typeof actor.states[state].on !== 'undefined') {
					// console.log('with on', actor.states[state].on);
					if (typeof actor.states[state].on[event] !== 'undefined') {
						// console.log('with event', actor.states[state].on[event]);
						let nextState = actor.states[state].on[event];
						let boundNext = nextState.next.bind(context);
						let boundStateTransition = boundNext(actor, otherActor, context);
						let reducedState = boundStateTransition;
						// the actor state it that of the time of calling, which is here in this lexical scope.
						actor.currentState = reducedState; // also update actor
						// call it again, but make sure the correct event would be passed
						if (this.debugMode === true) {
							console.log('[StateMachineModule] next state for state', state, 'and event', event, 'would be', reducedState, 'for actor', actor.id);
						}
						return reducedState;
					} else {
						if (typeof actor.states[state].on[event] === 'undefined') {
							if (this.debugMode === true || this.logExpectedUnhandledStates === true) {
								console.warn('[StateMachineModule] expected state happened where nothing needs to be done. Implicitly, this state does not have to be handled. Otherwise, add a state transition now for this state', state, 'and event', event);
							}
						}
					}
				}
			}
		}
	};

	/**
	 *  trigger the initialized state
	 * 
	 * @param eventName 
	 */
	setInitializedState = (actors, context) => {
		document.documentElement.addEventListener('initialized', (event) => {
			// let eventName = 'initialized';
			console.log(`custom initialized event triggered`);
			if (event.data) {
				console.log('initialize - event data:', event.data);
				actors.forEach((actor) => {
					actors.forEach((otherActor) => {
						if (actor !== otherActor) {
							console.log(`initialize - actor with id ${actor.id} and role ${actor.role} is in set of actors:`, actor);
							console.log(`initialize - otherActor with id ${otherActor.id} and role ${otherActor.role} is in set of actors:`, otherActor);
							actor.currentState = this.actorStateMachine(actor, otherActor, actor.initialState, 'tick', context);
							console.log('initialize - reduced state of actor with id ', actor.id, ' and role', actor.role, ' is', actor.currentState);
							console.log('initialize - --- in event listener for actor state machine event initialize');
							// ---
							// otherActor.currentState = this.actorStateMachine(otherActor, actor, otherActor.initialState, 'tick');
							// console.log('initialize - reduced state of otherActor with id ', otherActor.id, ' and role', otherActor.role, ' is', otherActor.currentState);
						} else {
							console.warn('comparing self, ignoring', actor); // would become filter
						}

					});
				});
			}
		});
		this.triggerEventOnElement('initialized', document.documentElement);
	}

	/**
	 * 
	 * Trigger event for state machine
	 * @param eventName 
	 * @param eventListenerElement 
	 */
	addEventListenerForStateMachine = (eventName = 'idle', eventListenerElement, actors, context) => {
		eventListenerElement.addEventListener(eventName, (event) => {
			// let eventName = 'initialized';
			if (this.debugMode === true) {
				console.log(`[StateMachineModule] addEventListenerForStateMachine - "${eventName}" event triggered`);
			}
			if (event.data) {
				if (this.debugMode === true) {
					console.log('[StateMachineModule] addEventListenerForStateMachine - event data:', event.data);
					console.log('[StateMachineModule] addEventListenerForStateMachine - [', actors.length, '] actors detected');
				}
				if (actors.length > 1) {
					// TODO: improve filtering
					actors.forEach((actor) => {
						actors.forEach((otherActor) => {
							if (actor !== otherActor) {
								actor.currentState = this.actorStateMachine(actor, otherActor, actor.currentState, eventName, context);
								if (this.debugMode === true) {
									console.log('[StateMachineModule] addEventListenerForStateMachine - reduced state is', actor.currentState);
									console.log(`[StateMachineModule] addEventListenerForStateMachine - actor with id ${actor.id} and role ${actor.role} is in set of actors:`, actor);
									console.log(`[StateMachineModule] addEventListenerForStateMachine - otherActor with id ${otherActor.id} and role ${otherActor.role} is in set of actors:`, otherActor);
								}
							} else {
								if (this.debugMode === true) {
									console.warn('[StateMachineModule] addEventListenerForStateMachine - comparing self, ignoring', actor); // would become filter
								}
							}
						});
					});
				} else {
					if (actors.length === 1) {
						if (this.debugMode === true) {
							console.log('[StateMachineModule] addEventListenerForStateMachine - [', actors.length, '] actor detected');
						}
						actors.forEach((actor) => {

							let currentState = this.actorStateMachine(actor, null, actor.currentState, eventName, context);
							if (currentState) {
								actor.currentState = currentState;
							}
							if (this.debugMode === true) {
								console.log(`[StateMachineModule] addEventListenerForStateMachine - actor with id ${actor.id} and role ${actor.role} is in set of actors:`, actor);
								console.log('[StateMachineModule] addEventListenerForStateMachine - reduced state is', actor.currentState);
							}
						});
					}
				}
			}
		});

	}

	/**
	 * 
	 * @param {Number} id 
	 * @returns 
	 */
	createActor(id) {
		return {
			id: id,
			role: 'actor',
			initialState: 'initialized',
			currentState: 'initialized',
			nextStates: [],
			states: {
				// first item example
				// if the state of the state machine is 'idle', define an object with states that can transition from the current state
				// if one is found it can be called, containing a next function returning a reduced state that can be the same as the current or the next.
				// If not, a state is not changed, so less unexpected behavior occurs than in a bottom-up approach
				// where more checks must occur for missing data
				'initialized': {
					on: {
						'tick': {
							next: (...args) => {
								let nextState = 'idle';
								return nextState;
							}
						},
					},
				},
				'idle': {
					on: {
						'tick': {
							next: (...args) => {
								let nextState = 'move';
								// console.log('MOVE...');
								return nextState;
							}
						},
					},
				},
				'move': {
					on: {
						'tick': {
							next: (...args) => {
								let nextState = 'observe';
								return nextState;
							}
						},
					},
				},
				'observe': {
					on: {
						'tick': {
							next: (...args) => {
								let nextState = 'idle';
								return nextState;
							}
						},
					},
				},
			}
		}
	}
}

